<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Detalhe da Fase"
                @click.stop="confirmarExcluirDetalhe()"
            ></i>
        </span>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        fase: {
            type: Object,
            default: () => ({})
        },

        detalheFase: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        confirmarExcluirDetalhe() {
            if (!this.contratoElaboracao() && !this.aditivarContrato()) {
                if (this.contratoApostilamento == null) {
                    this.$swal({
                        title: 'O que deseja fazer ?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Apostilar',
                        cancelButtonText: 'Atualizar'
                    }).then(result => {
                        if (result.value) {
                            this.alternaJustificativa(
                                result.value == true ? 1 : 0
                            )
                            this.mostrarAlerta()
                        } else if (result.isDismissed) {
                            this.alternaJustificativa(
                                result.isConfirmed == true ? 1 : 0
                            )
                            this.mostrarAlerta()
                        }
                    })
                } else if (this.contratoApostilamento == 1) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta()
                } else if (this.contratoApostilamento == 0) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta()
                }
            } else {
                this.$swal({
                    title: 'Detalhe da Fase do Contrato',
                    html: `Confirma a exclusão do detalhe de competência <b>${this.$moment(
                        this.detalheFase.mesPrevisto
                    ).format('MM/YYYY')}</b> da fase <b>${
                        this.fase.descricao
                    }</b>?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.excluirDetalhe()
                    }
                })
            }
        },

        mostrarAlerta() {
            this.$swal({
                title: 'Detalhe da Fase do Contrato',
                html: `Confirma a exclusão do detalhe de competência <b>${this.$moment(
                    this.detalheFase.mesPrevisto
                ).format('MM/YYYY')}</b> da fase <b>${
                    this.fase.descricao
                }</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a ${this.labelJustificativa}`,
                inputValidator: value => {
                    if (!value) {
                        return `A justificativa ${this.textoInfoJustificativa} é obrigatória'`
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.excluirDetalhe(result.value)
                }
            })
        },

        excluirDetalhe(justificativa) {
            this.$store.dispatch('addRequest')
            let detalheExcluidoDto = {
                detalheFaseContratoId: this.detalheFase.detalheFaseContratoId,
                faseContratoId: this.fase.faseContratoId,
                idContrato: this.$route.params.contratoId,
                justificativaApostilamento: justificativa,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.excluirDetalheFase(detalheExcluidoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.$toast.error(
                                'Falha ao excluir o detalhe da fase',
                                'OK',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Exclusão realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterDetalhesFaseAtualizados')
            this.$emit('obterComprometimentosAtualizados')
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'justificativa do apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = 'justificativa'
            }
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-06')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-06')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {},

    watch: {},

    validations: {}
}
</script>
